import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, errorTranslate } from "./util";
import { glossaryApiKey } from "./ApiKey/glossaryApiKey";

export const getGlossary = ({ setGlossaries }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/document/glossary",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  axios(config)
    .then(function (response) {
      setGlossaries(response.data.data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const addLikedGlossary = ({ glossary_id, triggerInvalidate }) => {
  const { createdLikedGlossary } = glossaryApiKey;
  var config = {
    method: "post",
    url: baseUrl + "/api/document/glossary/like/add",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      glossary_id: glossary_id,
    },
  };
  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      triggerInvalidate(createdLikedGlossary);
    })
    .catch(function (error) {
      let errorMessage =
        error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : "An unexpected error occurred";

      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: errorMessage,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};

export const getGlossaryLikes = ({ setGlossaryLikes }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/document/glossary/like",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  axios(config)
    .then(function (response) {
      setGlossaryLikes(response.data.data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteLikedGlossary = ({ id, triggerInvalidate }) => {
  const { removeLikedGlossary } = glossaryApiKey;
  var config = {
    method: "delete",
    url: baseUrl + "/api/document/glossary/like/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      triggerInvalidate(removeLikedGlossary);
    })
    .catch(function (error) {
      console.log(error);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};
